import helpers from '../helpers';

const init = () => {
	const chartJs = document.querySelector('.chart-js');
	const chartContainer = document.querySelector('.chart-course__graph');
	const chart = document.querySelector('.chart-course__graph svg');
	if (!chart) {
		return;
	}

	const popup = chartJs.querySelector('.chart-course__popup');
	const dot = chart.querySelectorAll('path[data-dot]');
	const point = chartJs.querySelector('.chart-course__dot');
	const data = {
		1: {
			info: '217, 1882 г.<br> первый выпуск',
		},
		2: {
			info: '163, 1883 г.',
		},
		3: {
			info: '112, 1884 г.',
		},
		4: {
			info: '113, 1885 г.',
		},
		5: {
			info: '117, 1886 г.',
		},
		6: {
			info: '120, 1887 г.',
		},
		7: {
			info: '128, 1888 г.',
		},
		8: {
			info: '119, 1889 г.',
		},
		// 9: {
		// 	info: '0, 1890 г.',
		// },
		// 10: {
		// 	info: '0, 1891 г.',
		// },
		// 11: {
		// 	info: '0, 1892 г.',
		// },
		9: {
			info: '61, 1893 г.',
		},
		10: {
			info: '49, 1894 г.',
		},
		11: {
			info: '60, 1895 г.',
		},
		12: {
			info: '93, 1896 г.',
		},
		13: {
			info: '120, 1897 г.',
		},
		14: {
			info: '106, 1898 г.',
		},
		15: {
			info: '80, 1899 г.',
		},
		16: {
			info: '126, 1900 г.',
		},
	};

	dot.forEach((item) => {
		item.addEventListener('mouseenter', (event) => {
			let dataPoint = event.currentTarget.getAttribute('data-dot');
			let rect = event.currentTarget.getBBox();
			let coef = chartContainer.offsetWidth / chart.getBBox().width;

			if (!dataPoint) {
				return;
			}

			popup.innerHTML = data[dataPoint].info;

			popup.style.left = `${rect.x * coef - popup.offsetWidth / 2}px`;
			popup.style.top = `${(rect.y + 10) * coef}px`;

			point.style.left = `${(rect.x - 3) * coef}px`;
			point.style.top = `${(rect.y - 3) * coef}px`;

			if (point.classList.contains('is-active')) {
				point.classList.remove('is-active');
				popup.classList.remove('is-active');
			}

			popup.classList.add('is-active');
			point.classList.add('is-active');
		});
	});

	chart.addEventListener('mouseleave', () => {
		if (point.classList.contains('is-active')) {
			point.classList.remove('is-active');
			popup.classList.remove('is-active');
		}
	});

	// let chartText1 = chartJs.querySelector('.charts__text.for-devices');

	// if (helpers.isMobile()) {
	// 	let timeLine = gsap.timeline().from(chartText1, 0.5, {
	// 		yPercent: 160,
	// 	});

	// 	// eslint-disable-next-line no-undef
	// 	ScrollTrigger.create({
	// 		animation: timeLine,
	// 		trigger: chartJs,
	// 		start: 'center center',
	// 		end: 'center bottom',
	// 		scrub: true,
	// 		markers: false,
	// 		onEnter() {
	// 			console.log('enters');
	// 		},
	// 		onUpdate(e) {
	// 			// if (e.progress * 100 < 60) {
	// 			// 	chartText1.style.bottom = `${e.progress * 100}%`;
	// 			// }
	// 		},
	// 	});
	// }

	if (helpers.isMobile()) {
		if (document.querySelector('.js-question-chart')) {
			const chartBlockEl = document.querySelector('.js-question-chart');

			// Trolley block
			const trolleyWrapper = chartBlockEl.closest('.static-chart-block-wrapper');

			// Block with text paragraphs
			const chartTextBlockEl = chartBlockEl.querySelector('.chart__description-wrapper');

			// Wrapper of .chart element
			const chartWrapperEl = chartBlockEl.querySelector('.chart-element');

			const chartEl = chartBlockEl.querySelector('.chart');
			// Distance from start of the block to it's parent
			// Distance to scroll
			let chartCols = chartBlockEl.querySelectorAll('.static-chart__col');

			const pinOffset = document.querySelector('.header').offsetHeight;

			const sectionST = ScrollTrigger.create({
				pin: trolleyWrapper,
				refreshPriority: 66,
				trigger: chartBlockEl,
				invalidateOnRefresh: true,
				id: 'question',
				markers: false,
				start: `top-=${pinOffset} top`,
				end: `top-=${pinOffset - 300} top`,
				onUpdate(e) {
					if (e.progress > 0.5) {
						chartCols[0].classList.add('static-chart__col--hidden');
						chartCols[1].classList.add('static-chart__col--visible');
					} else {
						chartCols[0].classList.remove('static-chart__col--hidden');
						chartCols[1].classList.remove('static-chart__col--visible');
					}
				},
				onLeave: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				},
				onLeavBack: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				}, // pin: chartBlockEl,
			});
		}
		if (document.querySelector('.js-medics-chart')) {
			const chartBlockEl = document.querySelector('.js-medics-chart');

			// Trolley block
			const trolleyWrapper = chartBlockEl.closest('.chart-block-wrapper');

			// Block with text paragraphs
			const chartTextBlockEl = chartBlockEl.querySelector('.chart__description-wrapper');

			// Wrapper of .chart element
			const chartWrapperEl = chartBlockEl.querySelector('.chart-element');

			const chartEl = chartBlockEl.querySelector('.chart');
			// Distance from start of the block to it's parent
			// Distance to scroll
			let chartMedicsText1 = chartBlockEl.querySelector('.charts__text.for-devices');

			const pinOffset = document.querySelector('.header').offsetHeight;

			const sectionST = ScrollTrigger.create({
				pin: trolleyWrapper,
				refreshPriority: 61,
				trigger: chartBlockEl,
				invalidateOnRefresh: true,
				id: 'doctors',
				markers: false,
				start: `top-=${pinOffset} top`,
				end: `top-=${pinOffset - 300} top`,
				onUpdate(e) {
				},
				onLeave: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				},
				onLeavBack: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				}, // pin: chartBlockEl,
			});

			const textST = ScrollTrigger.create({
				trigger: chartBlockEl,
				refreshPriority: 60,
				invalidateOnRefresh: true,
				markers: false, // id: 'p-1',
				start: `top-=${pinOffset} top`,
				end: `top-=${pinOffset - 300} top`,
				onUpdate(e) {
					if (helpers.isMobile()) {
						const progress = -e.progress * (chartEl.offsetHeight + chartMedicsText1.offsetHeight + 90);

						chartMedicsText1.style.transform = `translateY(${progress}px)`;
					}
				},
			});
		}
		if (document.querySelector('.js-occupation-chart')) {
			const chartBlockEl = document.querySelector('.js-occupation-chart');

			// Trolley block
			const trolleyWrapper = chartBlockEl.closest('.chart-block-wrapper');

			// Block with text paragraphs
			const chartTextBlockEl = chartBlockEl.querySelector('.chart__description-wrapper');

			// Wrapper of .chart element
			const chartWrapperEl = chartBlockEl.querySelector('.chart-element');
			// Distance from start of the block to it's parent
			// Distance to scroll
			let chartMedicsText1 = chartBlockEl.querySelector('.charts__text.for-devices');

			const pinOffset = document.querySelector('.header').offsetHeight;

			const sectionST = ScrollTrigger.create({
				pin: trolleyWrapper,
				refreshPriority: 61,
				trigger: chartBlockEl,
				invalidateOnRefresh: true,
				id: 'doctors',
				markers: false,
				start: `top-=${pinOffset} top`,
				end: `top-=${pinOffset - 300} top`,
				onUpdate(e) {
				},
				onLeave: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				},
				onLeavBack: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				}, // pin: chartBlockEl,
			});

			const textST = ScrollTrigger.create({
				trigger: chartBlockEl,
				refreshPriority: 60,
				invalidateOnRefresh: true,
				markers: false, // id: 'p-1',
				start: `top-=${pinOffset} top`,
				end: `top-=${pinOffset - 300} top`,
				onUpdate(e) {
					if (helpers.isMobile()) {
						const progress = -e.progress * (chartWrapperEl.offsetHeight + chartMedicsText1.offsetHeight + 15);

						chartMedicsText1.style.transform = `translateY(${progress}px)`;
					}
				},
			});
		}
		if (document.querySelector('.js-medics-chart2')) {
			const chartBlockEl = document.querySelector('.js-medics-chart2');

			// Trolley block
			const trolleyWrapper = chartBlockEl.closest('.trolley');

			// Block with text paragraphs
			const chartTextBlockEl = chartBlockEl.querySelector('.chart__description-wrapper');

			// Wrapper of .chart element
			const chartWrapperEl = chartBlockEl.querySelector('.chart-element');
			// Distance from start of the block to it's parent
			// Distance to scroll
			let chartMedicsText1 = chartBlockEl.querySelector('.charts__text.for-devices');

			const pinOffset = document.querySelector('.header').offsetHeight;

			const sectionST = ScrollTrigger.create({
				pin: trolleyWrapper,
				refreshPriority: 61,
				trigger: chartBlockEl,
				invalidateOnRefresh: true,
				id: 'doctors',
				markers: false,
				start: `top-=${pinOffset} top`,
				end: `top-=${pinOffset - 300} top`,
				onUpdate(e) {
				},
				onLeave: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				},
				onLeavBack: () => {
					trolleyWrapper.classList.remove('trolley-custom');
				}, // pin: chartBlockEl,
			});

			const textST = ScrollTrigger.create({
				trigger: chartBlockEl,
				refreshPriority: 60,
				invalidateOnRefresh: true,
				markers: false, // id: 'p-1',
				start: `top-=${pinOffset} top`,
				end: `top-=${pinOffset - 300} top`,
				onUpdate(e) {
					if (helpers.isMobile()) {
						const progress = -e.progress * (chartWrapperEl.offsetHeight + chartMedicsText1.offsetHeight + 15);

						chartMedicsText1.style.transform = `translateY(${progress}px)`;
					}
				},
			});
		}
	}
};

export default { init };
